export const isMobileApp = () => !!window.isMobileApp;
export const isNativeMobileApp = () => !!window.isNativeMobileApp;
